export type FieldType = 'text' | 'select' | 'date' | 'number';

export interface ActionFieldConfig {
  key: string;
  label: string;
  required?: boolean;
  tooltip?: string;
  helperText?: string;
  dynamicSource?: 'customers' | 'templates';
  options?: { label: string; value: string }[];
  defaultValue?: string;
  type?: 'select' | 'text' | 'textarea' | 'date';
   placeholder?: string;
}



export const ACTION_FIELD_SCHEMAS: Record<string, ActionFieldConfig[]> = {
  'project.create': [
    { key: 'projectName', label: 'Project name', type: 'text', placeholder: 'e.g. New onboarding for {{customerName}}' },
    { key: 'templateId', label: 'Template', type: 'select', dynamicSource: 'templates' },
    { key: 'customerId', label: 'Customer', type: 'select', dynamicSource: 'customers' },
    { key: 'startDate', label: 'Start Date', type: 'date' },
    { key: 'projectDescription', label: 'Project Description', type: 'text' },
    { key: 'dealId', label: 'Deal ID', type: 'text' },
    { key: 'dealcrmId', label: 'Deal CRM ID', type: 'text' },
  ],
  'customer.users.activateandinvite': [
    { key: 'customeruser', label: 'Customer user to invite', type: 'text', placeholder: 'e.g. ecea6653-afab-4ab6-974e-c62f71a0d505' },
    { key: 'customerId', label: 'Customer id', type: 'text', placeholder: 'e.g. ecea6653-afab-4ab6-974e-c62f71a0d505' },
    { key: 'sendinvite', label: 'Send invite', type: 'select', options: [ { label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' } ] },
  ],
  'customer.users.assigntotasks': [
    { key: 'customeruser', label: 'Customer user to assign', type: 'text', placeholder: 'e.g. ecea6653-afab-4ab6-974e-c62f71a0d505' },
    { key: 'projectId', label: 'Project ID', type: 'text', placeholder: 'e.g. 12345678-1234-1234-1234-123456789012' },
  ],
  'customer.users.list': [
    { key: 'customerId', label: 'Customer id', type: 'text', placeholder: 'e.g. ecea6653-afab-4ab6-974e-c62f71a0d505' },
  ],
  'lambda.invoke': [
    { key: 'lambdaName', label: 'Lambda function name', type: 'text', placeholder: 'e.g. myLambdaFunction' },
    { key: 'input', label: 'Lambda function input', type: 'text', placeholder: 'e.g. {"key": "value"}' },
  ],
  'customer': [
    { key: 'customerId', label: 'Customer id', type: 'text', placeholder: 'e.g. ecea6653-afab-4ab6-974e-c62f71a0d505' },
  ],
  /**
   * 
   * export class Task {
    taskId: string;
    projectId: string;
    title: string;
    description?: string;
    taskstate?: string;
    responsible?: string;
    stageId?: string;
    stagename?: string;
    startdate?: string;
    duedate?: string;
    creator: string;
    created: string;
    versioncreator: string;
    validfrom: string;
    validto: string;
    taskvisibility: string = 'Shared';
    projectname: string;
    projectdescription: string;
    organizationId: string;
    organizationname: string;
    orgdesc: string;
    orgemail: string;
    orgwww: string;
    orglogourl: string;
    customer: string;
    customername: string;
    show: boolean;
    canEdit: boolean;
    sortOrder: number;
    numberoffiles: number;
    tasktype: string = 'task';
    linkurl: string;
    linktext: string;
}
   */
  'task.add': [
    { key: 'title', label: 'Task Title', type: 'text', placeholder: 'e.g. Follow up with customer' },
    { key: 'taskdescription', label: 'Task Description', type: 'text', placeholder: 'e.g. Call the customer to discuss project details' },
    { key: 'duedate', label: 'Due Date', type: 'date' },
    { key: 'responsible', label: 'Responsible (User ID)', type: 'text', placeholder: 'e.g. user-1234' },
    { key: 'startdate', label: 'Start Date', type: 'date' },
    { key: 'tasktype', label: 'Task Type', type: 'select', options: [ 
      { label: 'Task', value: 'task' }, 
      { label: 'Event', value: 'event' }, 
      { label: 'Submit', value: 'submit' },
      { label: 'Download', value: 'download' },
      { label: 'Link', value: 'link' }
    ]},
    { key: 'taskstage', label: 'Task Stage ID', type: 'text', placeholder: 'e.g. stage-1234' },
    { key: 'projectId', label: 'Project ID', type: 'text', placeholder: 'e.g. 12345678-1234-1234-1234-123456789012' },
    { key: 'taskvisibility', label: 'Task Visibility', type: 'select', options: [ 
      { label: 'Shared', value: 'Shared' }, 
      { label: 'Private', value: 'Private' }
    ]},
    { key: 'linkurl', label: 'Link URL (for Link type)', type: 'text', placeholder: 'e.g. https://example.com' },
    { key: 'linktext', label: 'Link Text (for Link type)', type: 'text', placeholder: 'e.g. Click here' },
    { key: 'tasksortOrder', label: 'Sort Order', type: 'text', placeholder: 'e.g. 1' }

  ]
};